import React, { useState, useEffect } from "react";
import { Modal } from "@mui/material";
import swal from "sweetalert";
import moment from "moment";
import "../UI Component/Modal/Modal.css";
import Reschedule from "./image-removebg-preview.png";
import CheckMark from "./image-removebg-check.png";
import "./styles.scss";
import afterLoginApiAxios from "../../Util/API Calls/afterLogin";
import BookSchedule from "../BookSchedule/BookSchedule";
import Loader from "./../UI Component/Loader/Loader";
import Calendar from "react-calendar";
import "./../../globalStyles/calendarStyle.scss";
import CalenderIcon from "../../assets/calender_icon.png";
import DownArrowIcon from "../../assets/filled-down-arrow.png";
import Spinner from "react-bootstrap/Spinner";
import {
  disableHelpButton,
  enableHelpButton,
} from "../common/DisableHelpButton/DisableHelpButton";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";
import { C2CConsole } from "../../Util/Helper/C2CConsole";

const RescheduleModal = (props) => {
  const { callNextAppointmentWidget } = props;
  const [state, setState] = useState(1);

  const [appointmentRescheduleDateTime, setAppointmentRescheduleDateTime] =
    useState("");

  const [
    appountRescheduleConfirmDateTime,
    setAppountRescheduleConfirmDateTime,
  ] = useState("");

  const [selectedDate, setSelectedDate] = useState();
  const [selectedSlot, setSelectedSlot] = useState();
  const [startTime, setStartTime] = useState();
  const [loading, setLoading] = useState(false);
  const [counter, setCounter] = useState(0);
  const [fromCalender, setFromCalender] = useState(false);
  const [calenderDate, setCalenderDate] = useState(new Date());
  const [showCalendar, setShowCalendar] = useState(false);
  const [rescheduledDate, setRescheduleDate] = useState();
  let [track, changeTrack] = useState(1);

  const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
  const staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);
  const doctorClinicAssociation = localStorage.getItem(
    LOCALSTORAGEKEY.DOCTOR_CLINIC_ASSOCIATION
  );
  const staffClinicAssociation = localStorage.getItem(
    LOCALSTORAGEKEY.STAFF_CLINIC_ASSOCIATION
  );

  const handleDate = (date) => {
    setCalenderDate(date);
    setFromCalender(true);
    setShowCalendar(false);
    changeTrack(++track);
  };
  useEffect(() => {
    setSelectedSlot();
  }, [selectedDate]);

  useEffect(() => {
    if (props.openView) {
      // this is a hotfix, not a right code ==> Himanshu Rajput
      localStorage.setItem(
        "followup_consultation_type",
        props.appointment?.consultation_type_id
      );
      disableHelpButton();
      callRescheduleAppointment();
    }
    return () => {
      enableHelpButton();
    };
  }, [props.openView]);

  function callRescheduleAppointment() {
    let apiUrl = "doctor/auto-reschedule";
    let params = {
      appointment_id: props.appointment.appointment_id,
      appointment_date: props.appointment.appointment_date,
      doctor_id: props.doctor_id,
    };
    if (
      (doctorClinicAssociation == "true" || staffClinicAssociation == "true") &&
      clinicId
    ) {
      params["clinic_id"] = clinicId;
      apiUrl = "clinic/auto-reschedule";
    }
    if (staffId) {
      params["staff_id"] = staffId;
    }
    afterLoginApiAxios
      .post(
        apiUrl, //"doctor/auto-reschedule",
        {
          ...params,
        },
        {
          headers: {
            Authorization: `${window.localStorage.getItem("id_token")}`,
          },
        }
      )
      .then((response) => {
        if (response) {
          if (response.data.hasOwnProperty("statusCode")) {
            if (response.data.statusCode == 200) {
              setRescheduleDate(response?.data?.date);
              setAppointmentRescheduleDateTime(
                `${moment(response.data.time, "hh:mm:ssZ").format(
                  "hh:mm A"
                )} on ${moment(response.data.date).format("MMM DD, YYYY")}`
              );
              if (!response?.data?.time) {
                setAppointmentRescheduleDateTime(`Reschedule Not Available`);
              }
            } else if (response.data.statusCode == 516) {
              swal({
                title: "Unable to reschedule appointment",
                icon: "error",
                text: response.data.message,
                button: "Okay",
              });
            } else {
              setAppointmentRescheduleDateTime(`Reschedule Not Available`);
            }
          }
        }
      })
      .catch(function (error) {
        C2CConsole.log(error);
        closeModal();
        swal({
          title: "Something went wrong",
          icon: "error",
          button: "Okay",
        });
      });
  }

  const closeModal = () => {
    setAppointmentRescheduleDateTime("");
    props.closeView();
    setState(1);
  };

  const determineConsultType = (appointment) => {
    if (appointment.is_follow_up === "True") {
      return 1;
    } else if (
      !appointment.consultation_type_id ||
      appointment.consultation_type_id === 4
    ) {
      return "0";
    } else {
      return appointment.consultation_type_id;
    }
  };

  const getViewState = (state) => {
    switch (state) {
      case 1:
        return (
          <div className="d-flex align-items-center justify-content-center flex-column py-4 modal-style-stage1">
            <div>
              <img src={Reschedule} alt="" />
            </div>
            <div className="reschedule-title">Reschedule Appointment</div>
            <div className="reschedule-text px-3 my-3">
              Do you want to reschedule this appointment to your next available
              slot at <b>{appointmentRescheduleDateTime}</b>
            </div>
            <div className="d-flex align-items-center justify-content-center flex-column w-75">
              <button
                className="btn primary-cta-button rounded-pill mt-3 w-100"
                style={{
                  color: "white",
                  paddingTop: "0.6rem",
                  paddingBottom: "0.6rem",
                }}
                disabled={loading}
                onClick={() => {
                  confirmAutoNextSlot(props.appointment);
                }}
              >
                {loading ? (
                  <Spinner animation="border" />
                ) : (
                  "Reschedule to next available slot"
                )}
              </button>
              <button
                className="btn secondary-button rounded-pill mt-3 mb-3 w-100"
                style={{
                  paddingTop: "0.6rem",
                  paddingBottom: "0.6rem",
                }}
                onClick={() => {
                  setState(2);
                }}
              >
                Reschedule to any other slot
              </button>
            </div>
          </div>
        );
      case 2:
        return (
          <div className="d-flex reschedule-slots align-items-center justify-content-center flex-column p-4">
            <div className="booking-slots-div reschedule_scroll_style">
              <div
                className="cal-width"
                style={{ alignSelf: "flex-start", position: "relative" }}
              >
                <div
                  className="booking-date d-flex align-items-center"
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowCalendar(!showCalendar)}
                >
                  <span className="week-day">
                    {moment(calenderDate).format("dddd,")}
                  </span>
                  <span
                    className="cal-date ml-1"
                    style={{ borderBottom: "1px dotted" }}
                  >
                    {moment(calenderDate).format("DD MMM, YYYY")}
                    <span className="ml-1">
                      <img src={CalenderIcon} alt="calender icon" />
                    </span>
                  </span>
                  <span className="ml-1">
                    <img src={DownArrowIcon} alt="calender arrow" />
                  </span>
                </div>
                <div className="calendar-wrapper">
                  <Calendar
                    className={showCalendar ? "" : "hide"}
                    onChange={handleDate}
                    value={calenderDate}
                    minDate={new Date()}
                    maxDate={moment(new Date()).add(12, "months")._d}
                  />
                </div>
              </div>
              {loading && <Loader />}
              <BookSchedule
                style={{ minWidth: "40vw" }}
                followUpInfo={{
                  patient_id: props.appointment.patient_id,
                  patient_name: props.appointment.patient_name,
                  patient_dob: props.appointment.patient_dob,
                  doctor_id: props.doctor_id,
                  patient_account_id: props.appointment.patient_account_id,
                }}
                slugUrl={props.slugUrl}
                reschedule={true}
                consultType={determineConsultType(props.appointment)} //1 : 0 passing appointment consultation type id
                className={
                  "d-flex flex-column align-items-center justify-content-center mt-4"
                }
                doctorId={props.doctor_id}
                slotsClass={"mt-2"}
                hideAnnotation={true}
                track={track}
                fromCalender={fromCalender}
                calenderDate={calenderDate}
                setStartTime={(e) => {
                  if (e) {
                    localStorage.setItem("time", e);
                    setStartTime(e);
                  }
                }}
                onDateSelect={(e) => {
                  setCalenderDate(e.meta._d);
                  if (e) {
                    setSelectedDate(e);
                    localStorage.setItem(
                      "date",
                      moment(e.meta).format("YYYY-MM-DD")
                    );
                  }
                }}
                onSlotSelect={(e) => {
                  if (e) {
                    setSelectedSlot(e);
                    localStorage.setItem("slot_id", e);
                  }
                }}
                setCounter={setCounter}
                handleDate={handleDate}
                procedure_id={props.appointment.procedure_id} //passing procedure id from doctor
                isReschedule={true}
                booking_type={"doctor"}
              />
            </div>
            <button
              className="btn primary-cta-button rounded-pill mt-3 p-2 px-5"
              style={{
                minWidth: "160px",
                color: "white",
                paddingTop: "0.6rem",
                paddingBottom: "0.6rem",
              }}
              onClick={() => {
                rescheduleAppointment(props.appointment);
              }}
              disabled={!selectedSlot || loading}
            >
              Book
            </button>
          </div>
        );
      case 3:
        return (
          <div className="d-flex align-items-center justify-content-center flex-column p-4">
            <div>
              <img src={CheckMark} alt="" />
            </div>
            <div className="reschedule-title">Appointment Rescheduled</div>
            <div className="reschedule-text px-3 my-3">
              Your appointment has been rescheduled to{" "}
              <b>{appountRescheduleConfirmDateTime.split("to")[1]}</b>
            </div>
            <button
              className="btn primary-cta-button rounded-pill mt-3 p-2 px-5"
              style={{
                minWidth: "160px",
                color: "white",
                paddingTop: "0.6rem",
                paddingBottom: "0.6rem",
              }}
              onClick={() => {
                closeModal();
                props.refreshAppointmentsMethod();
              }}
            >
              Okay
            </button>
          </div>
        );
      default:
        return null;
    }
  };

  const rescheduleAppointment = (appointment) => {
    setLoading(true);

    let apiUrl = "doctor/reschedule-by-slot";
    let params = {
      appointment_id: appointment.appointment_id,
      appointment_slot_id: selectedSlot,
      appointment_date: moment(selectedDate.meta).format("YYYY-MM-DD"),
      doctor_id: props.user_id,
    };
    if (
      (doctorClinicAssociation == "true" || staffClinicAssociation == "true") &&
      clinicId
    ) {
      params["clinic_id"] = clinicId;
      apiUrl = "clinic/reschedule-by-slot";
    }
    if (staffId) {
      params["staff_id"] = staffId;
    }
    afterLoginApiAxios
      .post(
        apiUrl, //"doctor/reschedule-by-slot",
        {
          ...params,
        },
        {
          headers: {
            Authorization: `${window.localStorage.getItem("id_token")}`,
          },
        }
      )
      .then((response) => {
        if (response) {
          setLoading(false);
          if (response.data.hasOwnProperty("statusCode")) {
            if (response.data.statusCode == 200) {
              setAppountRescheduleConfirmDateTime(response.data.message);
              setState(3);
              callNextAppointmentWidget && callNextAppointmentWidget();
            } else {
              if (response.data.statusCode == 510) {
                swal({
                  title: "Sorry!",
                  icon: "error",
                  text: response.data.message,
                  button: "Okay",
                });
              } else if (response.data.statusCode == 516) {
                swal({
                  title: "Unable to reschedule appointment",
                  icon: "error",
                  text: response.data.message,
                  button: "Okay",
                });
              } else {
                closeModal();
                swal({
                  title: "Something went wrong",
                  icon: "error",
                  button: "Okay",
                });
              }
            }
          }
        }
      })
      .catch(function (error) {
        C2CConsole.log(error);
        closeModal();
        swal({
          title: "Something went wrong",
          icon: "error",
          button: "Okay",
        });
      });
  };
  const confirmAutoNextSlot = (appointment) => {
    setLoading(true);

    let apiUrl = "doctor/auto-reschedule";
    let params = {
      appointment_id: appointment.appointment_id,
      appointment_date:
        rescheduledDate && moment(rescheduledDate).format("YYYY-MM-DD"), //appointment.appointment_date,
      doctor_id: appointment.doctor_id,
      is_confirm: true,
    };
    if (
      (doctorClinicAssociation == "true" || staffClinicAssociation == "true") &&
      clinicId
    ) {
      params["clinic_id"] = clinicId;
      apiUrl = "clinic/auto-reschedule";
    }
    if (staffId) {
      params["staff_id"] = staffId;
    }
    afterLoginApiAxios
      .post(
        apiUrl, //"doctor/auto-reschedule",
        {
          ...params,
        },
        {
          headers: {
            Authorization: `${window.localStorage.getItem("id_token")}`,
          },
        }
      )
      .then((response) => {
        if (response) {
          setLoading(false);
          if (response.data.hasOwnProperty("statusCode")) {
            if (response.data.statusCode == 200) {
              setAppountRescheduleConfirmDateTime(response.data.message);
              setState(3);
              callNextAppointmentWidget && callNextAppointmentWidget();
            } else {
              closeModal();
              swal({
                title: "Sorry!",
                icon: "error",
                text: response.data.message,
                button: "Okay",
              });
            }
          }
        }
      })
      .catch(function (error) {
        C2CConsole.log(error);
        closeModal();
        swal({
          title: "Something went wrong",
          icon: "error",
          button: "Okay",
        });
      });
  };
  return (
    <>
      {props.openView ? (
        <Modal open={props.openView}>
          <div className="reschedule-modal-container">
            <div className="reschedule-modal-wrapper">
              <div className="d-flex align-items-center justify-content-end w-100 px-4 pt-2">
                <div
                  onClick={() => closeModal()}
                  className="cursor-pointer"
                  style={{ fontSize: "16px" }}
                >
                  Close X
                </div>
              </div>
              {getViewState(state)}
            </div>
          </div>
        </Modal>
      ) : null}
    </>
  );
};

export default RescheduleModal;
